export default __webpack_public_path__ + "static/media/deleteattachment.2beb4412.svg";